import { render, staticRenderFns } from "./TheLiteFooter.vue?vue&type=template&id=81abeac2&functional=true"
import script from "./TheLiteFooter.vue?vue&type=script&lang=js"
export * from "./TheLiteFooter.vue?vue&type=script&lang=js"
import style0 from "./TheLiteFooter.vue?vue&type=style&index=0&id=81abeac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports